import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import NotificationListItem from "../NotificationListItem";
import { Collection, CollectionStage, CollectionState, UserMetadata } from "../../types";
import Button from "../Button";
import { InputField } from "../InputField";
import { Routes } from "../../constants";
import { useAuth } from "../../contexts/AuthContext";
import { useApi } from "../../contexts/ApiContext";

type Props = {
  collections: Collection[];
  stage?: CollectionStage;
  state?: CollectionState;
};

const NotificationList = React.memo(({ collections, stage, state }: Props) => {
  const { push } = useHistory();
  const [searchValue, setSearchValue] = useState<string>("");
  const [listLength, setListLength] = useState(6);
  const [offset, setOffset] = useState(100)
  const [collecs, setCollecs] = useState<any[]>([])
  const filtered = collecs?.map((col) => {
    return { ...col, stage }
  })
  const { currentUserMetadata } = useAuth()
  const { retrieveCollectionsByType, retrieveDeletedCollections } = useApi()

  useEffect(() => {
    if (collections) {
      setCollecs([...collections])
    }
  }, [collections])


  const editCollection = (collection: Collection) => {
    if (stage === CollectionStage.draft) push(`${Routes.MANAGE_DRAFT}/${collection.id}`);
    else if (state === CollectionState.deleted) push(`${Routes.MANAGE_DELETED}/${collection.id}/`);
    else push(`${Routes.MANAGE_COLLECTION}/${collection.id}`);
  };

  const searchResults = filtered.filter(
    (collection) =>
      collection?.name?.toLowerCase()?.includes(searchValue) && collection
  );

  const dateOrderedArray = filtered.sort(
    (a, b) => b.createdAt - a.createdAt
  );


  const loadMoreItems = async () => {
    setListLength(current => current + 6);
    if (currentUserMetadata?.role === "admin") {
      const retrieveMoreCollections: any = state == CollectionState.deleted ?
        await retrieveDeletedCollections({ offset: offset, limit: 10,orderBy: '-modifiedAt' }) :
        await retrieveCollectionsByType({ offset: offset, limit: 10, state,orderBy: '-modifiedAt' }, CollectionState.live,);
          
      const moreCollections = retrieveMoreCollections ? retrieveMoreCollections : []
      setOffset(current => current + 10)
      setCollecs([...collecs, ...moreCollections])
    }

  }; 

  return (
    <Fragment>
      <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-4 lg:gap-8 w-full">
        {/* {currentUserMetadata?.role === "admin" && dateOrderedArray?.length > 5 && (
        <InputField
          onChange={(e) => setSearchValue(e.target.value)}
          value={searchValue}
          label="Search your Collections"
        />
      )} */}
        {dateOrderedArray.length > 0 && searchValue.length === 0
          ? dateOrderedArray.map(
            (collection, idx) =>
              idx + 1 <= listLength && (
                <NotificationListItem
                  onClick={(collection) => editCollection(collection)}
                  key={collection.id}
                  collection={collection}
                  state={state}
                />
              )
          )
          : searchResults?.map(
            (collection, idx) =>
              idx + 1 <= listLength && (
                <NotificationListItem
                  onClick={(collection) => editCollection(collection)}
                  key={collection.id}
                  collection={collection}
                  state={state}
                />
              )
          )}
        {dateOrderedArray?.length === 0 && (
          <div className="mb-6 mt-2">No collections at the moment.</div>
        )}
      </div>
      {dateOrderedArray?.length >= listLength && (
        <Button
          type="button"
          className="my-4 ml-auto mr-auto btn flex bg-gradient text-kyzzen-primary font-medium"
          onClick={loadMoreItems}
        >
          Show more
        </Button>
      )}
      <hr className="border border-gray-80 "/>
    </Fragment>
  );
});

export default NotificationList;
